import * as FoulTypes from "../subTypes/EliteFoulTypes";

export const CancellationFoulTypeSelect = {
  name: "cancellation-foul-type-select",
  component: "MainPanel",
  layout: "main-panel large",
  mode: "visible",
  text: "foul.type",
  showOn: [{ state: "primary", value: "cancellation-foul-type-select", operator: "is" }],
  startEvent: false,
  startPlay: false,
  allowFlag: true,
  allowCancel: true,
  allowCancelEvent: "main",
  showDetails: { events: ["main"] },
  allowBack: { state: "primary", value: "foul-type-select", event: "main" },
  children: [
    {
      name: "cancellation-coach-foul-types",
      component: "ButtonGroup",
      layout: "button-group",
      mode: "visible",
      showOn: [
        {
          state: "event.coach",
          value: true,
          operator: "is",
          event: "main",
        },
      ],
      options: {
        value: "subType",
        children: FoulTypes.CancellationCoachFoulTypes,
        layout: "type-button",
        prefix: "foul",
      },
      actionGroups: [
        {
          actions: [
            { action: "sendEvent", value: "new", type: "main" },
            { action: "newEventId", value: null, type: "main" },
            { action: "modifyEvent", value: "swapEntities", type: "main" },
            { action: "sendEvent", value: "new", type: "main" },
            { action: "nextState", value: null, type: "primary" },
            { action: "processInserts", value: "all", type: "inserts" },
          ],
          conditions: [
            {
              item: "subType",
              value: "coachDisqualifying",
              event: "main",
              operator: "is",
            },
          ],
        },
        {
          actions: [
            { action: "sendEvent", value: "new", type: "main" },
            { action: "copyEvent", value: "foul", type: "to" },
            // Because we need to clear `bench` and `coach` properties before next step
            { action: "newEvent", value: null, type: "main" },
            {
              action: "nextState",
              value: "cancellation-foul-drawn-player-select",
              type: "primary",
            },
          ],
          conditions: [
            {
              item: "subType",
              value: "coachDisqualifying",
              event: "main",
              operator: "not",
            },
          ],
        },
      ],
    },
    {
      name: "cancellation-bench-foul-types",
      component: "ButtonGroup",
      layout: "button-group",
      mode: "visible",
      showOn: [
        {
          state: "event.bench",
          value: true,
          operator: "is",
          event: "main",
        },
      ],
      startEvent: false,
      startPlay: false,
      options: {
        value: "subType",
        children: FoulTypes.CancellationBenchFoulTypes,
        layout: "type-button",
        prefix: "foul",
      },
      actionGroups: [
        {
          actions: [
            { action: "sendEvent", value: "new", type: "main" },
            { action: "copyEvent", value: "foul", type: "to" },
            // Because we need to clear `bench` and `coach` properties before next step
            { action: "newEvent", value: null, type: "main" },
            {
              action: "nextState",
              value: "cancellation-foul-drawn-player-select",
              type: "primary",
            },
          ],
          conditions: [],
        },
      ],
    },
  ],
};

export const CancellationFoulDrawnPlayerSelect = {
  name: "cancellation-foul-drawn-player-select",
  component: "MainPanel",
  layout: "main-panel large",
  mode: "visible",
  text: "fouldrawn.select-player",
  allowFlag: true,
  allowCancel: false,
  showDetails: { events: ["foul", "fouldrawn"] },
  showOn: [
    {
      state: "primary",
      value: "cancellation-foul-drawn-player-select",
      operator: "is",
    },
  ],
  allowBack: {
    state: "primary",
    value: "cancellation-foul-type-select",
    event: "foul",
  },
  children: [
    {
      name: "foul-drawn-player-select",
      component: "PlayerSelect",
      layout: "player-select",
      mode: "visible",
      showOn: [true],
      startEvent: false,
      startPlay: false,
      options: {
        currentEntity: false,
        currentEntityEvent: "foul",
        showBench: true,
        showCoach: true,
      },
      actionGroups: [
        {
          actions: [
            {
              action: "nextState",
              value: "cancellation-foul-drawn-type-select",
              type: "primary",
            },
          ],
          conditions: [
            {
              item: "bench",
              value: false,
              event: "main",
              operator: "is",
            },
            {
              item: "coach",
              value: false,
              event: "main",
              operator: "is",
            },
          ],
        },
        {
          actions: [
            { action: "newEventId", value: null, type: "main" },
            { action: "saveData", value: "foul", type: "eventType" },
            { action: "clearData", value: ["personId"] },
            { action: "saveData", value: "benchTechnical", type: "subType" },
            { action: "sendEvent", value: "new", type: "main" },
            { action: "nextState", value: null, type: "primary" },
            { action: "processInserts", value: "all", type: "inserts" },
          ],
          conditions: [
            {
              item: "bench",
              value: true,
              event: "main",
              operator: "is",
            },
          ],
        },
        {
          actions: [
            { action: "newEventId", value: null, type: "main" },
            { action: "saveData", value: "foul", type: "eventType" },
            { action: "saveData", value: "coachTechnical", type: "subType" },
            { action: "clearData", value: ["personId"] },
            { action: "sendEvent", value: "new", type: "main" },
            { action: "nextState", value: null, type: "primary" },
            { action: "processInserts", value: "all", type: "inserts" },
          ],
          conditions: [
            {
              item: "coach",
              value: true,
              event: "main",
              operator: "is",
            },
          ],
        },
      ],
    },
  ],
};

export const CancellationFoulDrawnTypeSelect = {
  name: "cancellation-foul-drawn-type-select",
  component: "MainPanel",
  layout: "main-panel large",
  mode: "visible",
  text: "foul.type",
  showOn: [{ state: "primary", value: "cancellation-foul-drawn-type-select", operator: "is" }],
  startEvent: false,
  startPlay: false,
  allowFlag: true,
  allowCancel: false,
  showDetails: { events: ["main"] },
  allowBack: {
    state: "primary",
    value: "cancellation-foul-drawn-player-select",
    event: "main",
  },
  children: [
    {
      name: "cancellation-foul-drawn-type-flagrant",
      component: "ButtonGroup",
      layout: "button-group",
      mode: "visible",
      showOn: [FoulTypes.FlagrantRuleSetShowOn],
      options: {
        value: "subType",
        children: ["categoryOneTechnical", "categoryTwoTechnical"],
        layout: "type-button",
        prefix: "foul",
      },
      actionGroups: [
        {
          actions: [
            { action: "saveData", value: "foul", type: "eventType" },
            { action: "sendEvent", value: "new", type: "main" },
            { action: "nextState", value: null, type: "primary" },
            { action: "processInserts", value: "all", type: "inserts" },
          ],
          conditions: [],
        },
      ],
    },
    {
      name: "cancellation-foul-drawn-type",
      component: "ButtonGroup",
      layout: "button-group",
      mode: "visible",
      showOn: [FoulTypes.UnsportsmanlikeRuleSetShowOn],
      options: {
        value: "subType",
        children: ["technical"],
        layout: "type-button",
        prefix: "foul",
      },
      actionGroups: [
        {
          actions: [
            { action: "saveData", value: "foul", type: "eventType" },
            { action: "sendEvent", value: "new", type: "main" },
            { action: "nextState", value: null, type: "primary" },
            { action: "processInserts", value: "all", type: "inserts" },
          ],
          conditions: [],
        },
      ],
    },
  ],
};
